import ExcluirRelatorioAjuste from '@/templates/Relatorios/Ajustes/ExcluirRelatorioAjuste'
import RelatorioAjustes from 'pages/RelatorioAjustes'
import React from 'react'
import { RouteObject } from 'react-router-dom'
import DetalhesRegistroReadOnly from 'templates/Admin/Clientes/modals/DetalhesRegistroLeitura'
import DetalhesDescontoDSR from 'templates/Relatorios/DSR/DetalhesDescontoDSR'
import ConfiguracaoEspelhoPonto from 'templates/Relatorios/EspelhoPontoV2/modals/Configuracao'
import ConfiguracaoValeAlimentacao from 'templates/Relatorios/ValeAlimentacao/atoms/Configuracao'
import DetalhesValeAlimentacao from 'templates/Relatorios/ValeAlimentacao/atoms/Detalhes'

const AdicionaisNoturno = React.lazy(
    () => import('@/pages/RelatorioAdicionalNoturno'),
)
const EspelhoPonto = React.lazy(() => import('pages/EspelhoPonto'))
const ComprovantePonto = React.lazy(() => import('pages/ComprovantePonto'))
const RelatorioSaldoHoras = React.lazy(
    () => import('pages/RelatorioSaldoHoras'),
)
const RelatorioInconsistencias = React.lazy(
    () => import('pages/RelatorioInconsistencias'),
)
const RelatorioValeAlimentacao = React.lazy(
    () => import('pages/RelatorioValeAlimentacao'),
)
const RelatorioAbsenteismo = React.lazy(
    () => import('pages/RelatorioAbsenteismo'),
)
const RelatorioRegistrosForaCerca = React.lazy(
    () => import('pages/RelatorioRegistrosForaCerca'),
)
const RelatorioAceiteEspelho = React.lazy(
    () => import('pages/RelatorioAceiteEspelho'),
)
const RealtorioRegistrosExcluidos = React.lazy(
    () => import('pages/RelatorioRegistrosExcluidos'),
)
const RelatorioDescontoDSR = React.lazy(
    () => import('pages/RelatorioDescontoDSR'),
)
const RelatorioHorasTrabalhadas = React.lazy(
    () => import('pages/RelatorioHorasTrabalhadas'),
)
const TrocaHorarios = React.lazy(() => import('pages/TrocaTabelaHorarios'))
const HorasSuprimidas = React.lazy(
    () => import('pages/RelatorioHorasSuprimidas'),
)
const RelatorioPontoDiario = React.lazy(
    () => import('pages/RelatorioPontoDiario'),
)
const RelatoriosAjustesImpressos = React.lazy(
    () => import('templates/Relatorios/Ajustes/RelatoriosImpressos'),
)
const HistoricoAceiteEspelhoPonto = React.lazy(
    () => import('templates/Relatorios/EspelhoPonto/HistoricoAceite'),
)

const base = '/relatorios'

export const relatorios: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/ajustes',
            element: <RelatorioAjustes />,
            children: [
                {
                    path: base + '/ajustes/impressos',
                    element: <RelatoriosAjustesImpressos />,
                    index: true,
                    children: [
                        {
                            path: base + '/ajustes/impressos/:hash/excluir',
                            element: <ExcluirRelatorioAjuste />,
                        },
                    ] as any,
                },
            ],
        },
        {
            path: base + '/adicional-noturno',
            element: <AdicionaisNoturno />,
        },
        {
            path: base + '/espelho-ponto',
            element: <EspelhoPonto />,
            children: [
                {
                    path: base + '/espelho-ponto/configuracao',
                    element: <ConfiguracaoEspelhoPonto />,
                },
            ],
        },
        {
            path: base + '/aceite-espelho',
            element: <RelatorioAceiteEspelho />,
            children: [
                {
                    path: base + '/aceite-espelho/historico',
                    element: <HistoricoAceiteEspelhoPonto />,
                    index: true,
                },
            ],
        },
        {
            path: base + '/saldo-horas',
            element: <RelatorioSaldoHoras />,
        },
        {
            path: base + '/inconsistencias',
            element: <RelatorioInconsistencias />,
        },
        {
            path: base + '/vale-alimentacao',
            element: <RelatorioValeAlimentacao />,
            children: [
                {
                    path: base + '/vale-alimentacao/:funcionarioId',
                    element: <DetalhesValeAlimentacao />,
                },
                {
                    path: base + '/vale-alimentacao/configuracao',
                    element: <ConfiguracaoValeAlimentacao />,
                },
            ],
        },

        {
            path: base + '/comprovante-ponto',
            element: <ComprovantePonto />,
        },

        {
            path: base + '/troca-horario',
            element: <TrocaHorarios />,
        },
        {
            path: base + '/absenteismo',
            element: <RelatorioAbsenteismo />,
        },
        {
            path: base + '/registros-fora-cerca',
            element: <RelatorioRegistrosForaCerca />,
            children: [
                {
                    path: base + '/registros-fora-cerca/:registroId/detalhes',
                    element: <DetalhesRegistroReadOnly />,
                },
            ],
        },
        {
            path: base + '/registros-excluidos',
            element: <RealtorioRegistrosExcluidos />,
            children: [
                {
                    path: base + '/registros-excluidos/:registroId/detalhes',
                    element: <DetalhesRegistroReadOnly />,
                },
            ],
        },
        {
            path: base + '/desconto-dsr',
            element: <RelatorioDescontoDSR />,
            children: [
                {
                    path: base + '/desconto-dsr/:id/detalhes',
                    element: <DetalhesDescontoDSR />,
                },
            ],
        },
        {
            path: base + '/horas-trabalhadas',
            element: <RelatorioHorasTrabalhadas />,
        },
        {
            path: base + '/horas-suprimidas',
            element: <HorasSuprimidas />,
        },
        {
            path: base + '/ponto-diario',
            element: <RelatorioPontoDiario />,
        },
    ],
}
